module.exports = __webpack_public_path__ + "img/Millionaire-2.7c4b56b9.png";